<a class="skip-link" href="#main-content">Saltar al contenido</a>

<div class="min-h-screen flex flex-col bg-background text-app-text">
  <header class="flex flex-wrap items-center justify-between gap-4 border-b border-primary/30 bg-primary text-primary-contrast px-5 py-4 shadow-[0_4px_20px_-4px_rgba(46,28,16,0.35)]">
    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        class="mobile-menu-toggle"
        aria-expanded="{{ menuOpen() }}"
        aria-controls="main-navigation"
        (click)="toggleMenu()"
      >
        ☰
      </button>
      <h1 class="text-xl m-0">Escuela Asturiana de Esgrima Antigua</h1>
      <button
        class="logout-button rounded-full border border-primary-contrast/60 bg-transparent px-4 py-2 text-primary-contrast"
        *ngIf="authService.isAuthenticated()"
        (click)="logout()"
      >
        Cerrar sesión
      </button>
    </div>

    <nav
      id="main-navigation"
      aria-label="Navegacion principal"
      class="topbar-nav flex flex-wrap gap-2"
      [class.mobile-hidden]="!menuOpen()"
    >
      <a
        class="inline-flex rounded-full border border-primary-contrast/50 bg-primary-contrast/10 px-3 py-1 text-primary-contrast no-underline transition hover:bg-primary-contrast/25 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-contrast"
        routerLink="/"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="closeMenu()"
      >
        Inicio
      </a>

      <ng-container *ngIf="!authService.isAuthenticated(); else authenticatedLinks">
        <a
          class="inline-flex rounded-full border border-primary-contrast/50 bg-primary-contrast/10 px-3 py-1 text-primary-contrast no-underline transition hover:bg-primary-contrast/25 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-contrast"
          routerLink="/auth"
          routerLinkActive="is-active"
          (click)="closeMenu()"
        >
          Auth
        </a>
      </ng-container>

      <ng-template #authenticatedLinks>
        <a
          class="inline-flex rounded-full border border-primary-contrast/50 bg-primary-contrast/10 px-3 py-1 text-primary-contrast no-underline transition hover:bg-primary-contrast/25 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-contrast"
          routerLink="/student"
          routerLinkActive="is-active"
          (click)="closeMenu()"
        >
          Alumno
        </a>
        <a
          class="inline-flex rounded-full border border-primary-contrast/50 bg-primary-contrast/10 px-3 py-1 text-primary-contrast no-underline transition hover:bg-primary-contrast/25 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-contrast"
          routerLink="/shop"
          routerLinkActive="is-active"
          (click)="closeMenu()"
        >
          Tienda
        </a>
        <a
          *ngIf="authService.userRole() === 'ADMIN'"
          class="inline-flex rounded-full border border-primary-contrast/50 bg-primary-contrast/10 px-3 py-1 text-primary-contrast no-underline transition hover:bg-primary-contrast/25 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-contrast"
          routerLink="/admin"
          routerLinkActive="is-active"
          (click)="closeMenu()"
        >
          Admin
        </a>
      </ng-template>
    </nav>
  </header>

  <main id="main-content" class="flex-1 mx-auto max-w-275 p-5" tabindex="-1">
    <router-outlet />
  </main>

  <footer class="border-t border-app-border bg-footer px-5 py-4">
    <div class="footer-content mx-auto flex flex-wrap items-center justify-between gap-3 max-w-275">
      <div class="font-semibold">Temas:</div>
      <div class="theme-buttons flex flex-wrap gap-2">
        <button
          type="button"
          class="rounded-full border border-app-border bg-transparent px-4 py-2 text-app-text"
          [class.active]="themeService.theme() === 'auto'"
          (click)="themeService.setTheme('auto')"
        >
          Auto
        </button>
        <button
          type="button"
          class="rounded-full border border-app-border bg-transparent px-4 py-2 text-app-text"
          [class.active]="themeService.theme() === 'light'"
          (click)="themeService.setTheme('light')"
        >
          Claro
        </button>
        <button
          type="button"
          class="rounded-full border border-app-border bg-transparent px-4 py-2 text-app-text"
          [class.active]="themeService.theme() === 'dark'"
          (click)="themeService.setTheme('dark')"
        >
          Oscuro
        </button>
      </div>
      <div class="theme-hint">
        Tema actual: {{ themeService.theme() === 'auto' ? 'Auto (sistema)' : themeService.theme() === 'dark' ? 'Oscuro' : 'Claro' }}
      </div>
    </div>
  </footer>
</div>
